module.exports = __webpack_public_path__ + "static/img/share_tisp.1511962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share_tisp.png
// module id = 1xof
// module chunks = 1